/* ZUMI — live Google rating + review count.
   Reads the Place ID and a referrer-restricted Places API (New) key from the top bar
   (#zumi-bar data attributes, set in Customize › Top bar). One request per visitor per
   24 h (localStorage cache), then updates every element carrying data-zumi-google="rating"
   or data-zumi-google="count", plus any sticker text that says "… N reviews". */
(function () {
  var host = document.getElementById('zumi-bar') || document.getElementById('morii-teahouse');
  if (!host) return;
  var key = host.getAttribute('data-api-key'), pid = host.getAttribute('data-place-id');
  if (!key || !pid) return;
  var KEY = 'zumi_google_' + pid, now = Date.now();
  function apply(r, c) {
    if (r) document.querySelectorAll('[data-zumi-google="rating"]').forEach(function (el) { el.textContent = Number(r).toFixed(1); });
    if (c) {
      document.querySelectorAll('[data-zumi-google="count"]').forEach(function (el) { el.textContent = c; });
      document.querySelectorAll('.zumi-stk, .zumi-bar__msg').forEach(function (el) {
        if (/\d[\d\s]*\s*reviews/i.test(el.textContent)) el.textContent = el.textContent.replace(/\d[\d\s]*(?=\s*reviews)/i, c + ' ');
      });
    }
  }
  try {
    var cached = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (cached && now - cached.t < 86400000) { apply(cached.r, cached.c); return; }
  } catch (e) {}
  fetch('https://places.googleapis.com/v1/places/' + encodeURIComponent(pid) + '?fields=rating,userRatingCount&key=' + encodeURIComponent(key))
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (d) {
      if (!d || !d.rating) return;
      apply(d.rating, d.userRatingCount);
      try { localStorage.setItem(KEY, JSON.stringify({ t: now, r: d.rating, c: d.userRatingCount })); } catch (e) {}
    }).catch(function () {});
})();
